import {ITopicCommentDto} from 'store/slices/request-slice/request-slice-type';

export const setValueForAllReplies = (items: ITopicCommentDto[], value: boolean): Record<string, boolean> =>
    items?.reduce((acc: Record<string, boolean>, item: ITopicCommentDto, index: number) => {
        acc[index] = value;
        return acc;
    }, {});
